<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card color="grey">
      <v-toolbar
        :flat="!!$vuetify.theme.dark"
        color="primary"
      >
        <v-toolbar-title>{{ prospectPacket.loggedInUser.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            text
            @click="impersonate"
          >
            <v-icon left>mdi-account-supervisor</v-icon>
            Impersonate
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            text
            @click="dialog = false"
          >Close</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="mt-16 px-0">
        <v-container class="pa-0">
          <v-card
            class="ma-0 pt-0"
            style="justify-content: center;"
            max-width="1200"
          >
            <v-toolbar style="background-color: #15a6b6 !important; color: white !important;">
              <v-toolbar-title>{{ prospectPacket.companyInfo.legalName }}</v-toolbar-title>
            </v-toolbar>
            <v-tabs vertical>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-office-building</v-icon>
                General
              </v-tab>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-map</v-icon>
                Locations
              </v-tab>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-bank</v-icon>
                Payroll
              </v-tab>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-contacts</v-icon>
                Contacts
              </v-tab>
              <v-tab
                v-if="prospectPacket.flags.hasBenefitPacket"
                style="justify-content: unset; text-transform: unset;"
              >
                <v-icon left>mdi-heart-pulse</v-icon>
                Health
              </v-tab>
              <v-tab
                v-if="prospectPacket.flags.hasBenefitPacket"
                style="justify-content: unset; text-transform: unset;"
              >
                <v-icon left>mdi-account-heart</v-icon>
                COBRA
              </v-tab>
              <v-tab
                v-if="prospectPacket.flags.hasBenefitPacket"
                style="justify-content: unset; text-transform: unset;"
              >
                <v-icon left>mdi-pill</v-icon>
                Illness
              </v-tab>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-signature</v-icon>
                Signatures
              </v-tab>
              <v-tab style="justify-content: unset; text-transform: unset;">
                <v-icon left>mdi-file-document-multiple</v-icon>
                Documents
              </v-tab>
              <v-tab-item>
                <v-card flat>
                  <GeneralCompanyInfo />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <OfficeLocations />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <CompanyPayrollInfo />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <UserContacts />
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="prospectPacket.flags.hasBenefitPacket">
                <v-card flat>
                  <CurrentInsurance />
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="prospectPacket.flags.hasBenefitPacket">
                <v-card flat>
                  <CobraEmployees />
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="prospectPacket.flags.hasBenefitPacket">
                <v-card flat>
                  <BenefitsIllness />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <UserSignatures />
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <UserDocuments />
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProspectPacketDefaults from '@/Data/ProspectPacket';

import GeneralCompanyInfo from './Categories/GeneralCompanyInfo.vue';
import OfficeLocations from './Categories/OfficeLocations.vue';
import CompanyPayrollInfo from './Categories/CompanyPayrollInfo.vue';
import UserContacts from './Categories/UserContacts.vue';
import CurrentInsurance from './Categories/CurrentHealthInsurance.vue';
import CobraEmployees from './Categories/CobraEmployees.vue';
import UserDocuments from './Categories/UserDocuments.vue';
import BenefitsIllness from './Categories/BenefitsIllness.vue';
import UserSignatures from './Categories/UserSignatures.vue';

export default {
  name: 'UserInfoDialog',
  components: {
    GeneralCompanyInfo,
    OfficeLocations,
    CompanyPayrollInfo,
    UserContacts,
    CurrentInsurance,
    CobraEmployees,
    UserDocuments,
    BenefitsIllness,
    UserSignatures,
  },
  data: () => ({
    attrs: {
      fixed: true,
    },
  }),
  computed: {
    dialog: {
      get() {
        return this.$store.state.userInfo.userInfoDialog;
      },
      set(value) {
        this.$store.commit('updateUserInfoDialog', value);
      },
    },
    packetGuid() {
      return this.$store.state.userInfo.packetGuid;
    },
    prospectPacket() {
      if (this.$store.state.prospectPacket) {
        return this.$store.state.prospectPacket;
      }

      return ProspectPacketDefaults;
    },
  },
  methods: {
    impersonate() {
      sessionStorage.setItem('packetGuid', this.packetGuid);
      this.$store.dispatch('SetImpersonationFlag').then(() => {
        if (this.$store.state.userInfo.impersonated) {
          this.$store.commit('updateUserInfoDialog', false);
          this.$router.push({ name: 'Register' });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
